export default __webpack_public_path__ + "static/media/supper_apps_background_xl1.f00b55d7.jpg";